import styles from "./VersionInfo.module.css";
import { useEffect } from "react";

export const VersionInfo = () => {
  useEffect(() => {
    if (window) {
      window.calculatorVersionInfo = {
        appVersion: "__CALCULATOR_APP_VERSION__",
        libraryVersion: "__CALCULATOR_LIB_VERSION__",
      };
    }
  }, []);
  return (
    <div className={styles.versionInfo}>
      <p>App Version: {window?.calculatorVersionInfo?.appVersion}</p>
      <p>Library Version: {window?.calculatorVersionInfo?.libraryVersion} </p>
    </div>
  );
};
